import React, { useState } from 'react';
import { Table, Spinner } from 'react-bootstrap';

import CustomModal from 'components/Modal/CustomModal';
import { TEST_IDS } from './testIds';

const formatDate = (value) => {
  if (!value) {
    return '—';
  }
  return new Date(value).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

const statusLabel = (apiKey) => {
  if (apiKey.revoked_at) {
    return <span className="badge bg-secondary">Revoked</span>;
  }
  if (apiKey.expires_at && new Date(apiKey.expires_at) <= new Date()) {
    return <span className="badge bg-warning text-dark">Expired</span>;
  }
  return <span className="badge bg-success">Active</span>;
};

const ApiKeyList = ({ apiKeys, loading, onRevoke }) => {
  const [pendingKey, setPendingKey] = useState(null);
  const [revoking, setRevoking] = useState(false);

  const closeConfirm = () => {
    if (!revoking) {
      setPendingKey(null);
    }
  };

  const confirmRevoke = async () => {
    setRevoking(true);
    try {
      await onRevoke(pendingKey);
    } finally {
      setRevoking(false);
      setPendingKey(null);
    }
  };

  if (loading) {
    return (
      <div className="text-center p-4">
        <Spinner animation="grow" />
      </div>
    );
  }

  if (!apiKeys.length) {
    return (
      <p className="text-muted mb-0" data-testid={TEST_IDS.EMPTY_STATE}>
        You haven't created any API keys yet.
      </p>
    );
  }

  return (
    <>
      <div className="table-responsive">
        <Table responsive className="table-payout" data-testid={TEST_IDS.KEY_TABLE}>
          <thead>
            <tr>
              <th className="product-head">Name</th>
              <th className="product-head">Key</th>
              <th className="product-head">Status</th>
              <th className="product-head">Created</th>
              <th className="product-head">Last used</th>
              <th className="action-head">Action</th>
            </tr>
          </thead>
          <tbody>
            {apiKeys.map((apiKey) => (
              <tr key={apiKey.id} data-testid={TEST_IDS.KEY_ROW}>
                <td>{apiKey.name}</td>
                <td>
                  <code>pb_live_{apiKey.prefix}…</code>
                </td>
                <td>{statusLabel(apiKey)}</td>
                <td>{formatDate(apiKey.created_at)}</td>
                <td>{formatDate(apiKey.last_used_at)}</td>
                <td>
                  {apiKey.revoked_at ? null : (
                    <button
                      type="button"
                      className="btn bg-danger text-white m-1"
                      onClick={() => setPendingKey(apiKey)}
                      data-testid={TEST_IDS.REVOKE_BTN}
                    >
                      Revoke
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <CustomModal
        showStatus={pendingKey !== null}
        clickStatus={closeConfirm}
        closeStatus={closeConfirm}
        buttonMessage="Cancel"
        title="Revoke this API key?"
        message={
          `Any integration using "${pendingKey?.name}" will stop working ` +
          'immediately. This cannot be undone.'
        }
        secondButton
        secondMessage="Revoke"
        secondButtonAction={confirmRevoke}
        loading={revoking}
      />
    </>
  );
};

export default ApiKeyList;
